import { render, staticRenderFns } from "./commentscandidates.vue?vue&type=template&id=db9eda80&lang=html&"
import script from "./commentscandidates.vue?vue&type=script&lang=js&"
export * from "./commentscandidates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports